/**
 * 平台菜单
 */

export default [
  {
    label: 'menu.sys001', //系统设置
    icon: 'icon-xitongshezhi',
    permission: 'taxcloud5025',
    id:'5025',
    path: '/sys',
    children: [
      {
        label: 'menu.sys002', //基础信息
        icon: 'm-baseinfomation',
        permission: 'taxcloud5030',
        id:'5030',
        path: '/baseInfo',
        children: [
          {
            label: 'menu.sys003', //部门管理
            path: '/baseInfo/deptManage.action',
            permission: 'taxcloud5036',
            id:'5036'
          },
          {
            label: 'menu.sys004', //人员管理
            path: '/baseInfo/personManage.action',
            permission: 'taxcloud5040',
            id:'5040'
          },
          {
            label: 'menu.sys005',//账户管理
            path: '/CustomBank_List.action',
            permission: 'taxcloud5060',
            id:'5060'
          },
          {
            label: 'menu.sys006',//供应商管理
            path: '/baseInfo/supplierManage.action',
            permission: 'taxcloud5050',
            id:'5050'
          },
          {
            label: 'menu.sys007',//项目组管理
            path: '/baseInfo/projectManage.action',
            permission: 'taxcloud5055',
            id:'5055'
          },
          {
            label: 'menu.sys008',//费用项目管理
            path: '/proManage/manageIndex.action',
            permission: 'taxcloud6000',
            id:'6000'
          },
          {
            label: 'menu.sys009',//票据类型管理
            path: '/receipt/toReceiptTypePage.action',
            permission: 'taxcloud6001',
            id:'6001'
          },
          {
            label: 'menu.sys010',//票据项目管理
            path: '/proManage/toInvoiceProject.action',
            permission: 'taxcloud8022',
            id:'8022'
          },
          {
            label: 'menu.sys011',//印鉴管理
            path: '/cost/costAction_toSealManager.action',
            permission: 'taxcloud',
            id:'8101'
          },
          {
            label: 'menu.sys012',//物品类型设置
            path: '/inventory/inventoryAction_toInventoryItemType.action',
            permission: 'taxcloud8121',
            id:'8121'
          },
          {
            label: 'menu.sys013',//物品设置
            path: '/inventory/inventoryAction_toInventoryItem.action',
            permission: 'taxcloud8122',
            id:'8122'
          },
          {
            label: 'menu.sys014',//初始化仓库
            path: '/inventory/inventoryAction_toBatchInitStorage.action',
            permission: 'taxcloud8129',
            id:'8129'
          },
        ]
      },
      {
        label: 'menu.sys015',//权限管理
        icon: 'm-quanxianguanli',
        permission: 'taxcloud5065',
        id:'5065',
        path: '/pms',
        children: [
          {
            label: 'menu.sys016',//角色管理
            path: '/pms/roleList.action',
            permission: 'taxcloud5070',
            id:'5070'
          },
          {
            label: 'menu.sys017',//用户管理
            path: '/pms/userManagement.action',
            permission: 'taxcloud5075',
            id:'5075'
          },
          {
            label: 'menu.sys018',//用户授权
            path: '/pms/personUserIndex.action',
            permission: 'taxcloud5080',
            id:'5080'
          },
          {
            label: 'menu.sys019',//转授权
            path: '/pms/powerTransfer.action',
            permission: 'taxcloud5082',
            id:'5082'
          },
        ]
      },
      {
        label: 'menu.sys020',//预算管理
        icon: 'm-yusuanguanli',
        permission: 'taxcloud7010',
        id:'7010',
        path: '/budget/budget.action',
      },
      {
        label: 'menu.sys021',//流程设置
        icon: 'm-process-settings',
        permission: 'taxcloud5084',
        id:'5084',
        path: '/process',
        children: [
          {
            label: 'menu.sys022',//报销流程设置
            path: '/custom/processList.action',
            permission: 'taxcloud5085',
            id:'5085'
          },
          {
            label: 'menu.sys023',//借款流程设置
            path: '/custom/borrowProcessList.action',
            permission: 'taxcloud5086',
            id:'5086'
          },
          {
            label: 'menu.sys024',//差旅申请流程设置
            path: '/custom/applicationProcessList.action',
            permission: 'taxcloud5087',
            id:'5087'
          },
          {
            label: 'menu.sys025',//合同审批流程设置
            path: '/custom/contractProcessList.action',
            permission: 'taxcloud5088',
            id:'5088'
          },
          {
            label: 'menu.sys026',//发票审批流程设置
            path: '/custom/fapiaoProcessList.action',
            permission: 'taxcloud5089',
            id:'5089'
          },
          {
            label: 'menu.sys027',//印鉴审批流程设置
            path: '/cost/costAction_toSealProcess.action',
            permission: 'taxcloud8102',
            id:'8102'
          },
          {
            label: 'menu.sys028',//库存审批流程设置
            path: '/inventory/inventoryAction_toInventoryProcess.action',
            permission: 'taxcloud8123',
            id:'8123'
          },
        ]
      },

      {
        label: 'menu.sys029',//合同设置
        icon: 'm-hetongshizhi',
        permission: 'taxcloud7022',
        id:'7022',
        path: '/contract',
        children: [
          {
            label: 'menu.sys030',//合同模板
            path: '/contract/contract_templateIndex.action',
            permission: 'taxcloud7023',
            id:'7023'
          },
          {
            label: 'menu.sys031',//合同编号设置
            path: '/contract/contract_numberIndex.action',
            permission: 'taxcloud7027',
            id:'7027'
          },
        ]
      },

      {
        label: 'menu.sys032',//自定义设置
        icon: 'm-zidingyishezhi',
        permission: 'taxcloud5090',
        id:'5090',
        path: '/customize',
        children: [
          {
            label: 'menu.sys033',//邮件模板设置
            path: '/custom/toMailTemplate.action',
            permission: 'taxcloud5091',
            id:'5091'
          },
          {
            label: 'menu.sys034',//报销类型设置
            path: '/cost/userDefinedCostAction_initDefinedClassName.action',
            permission: 'taxcloud5092',
            id:'5092'
          },
          {
            label: 'menu.sys035',//预算类别设置
            path: '/budget/BudgetSetPage.action',
            permission: 'taxcloud7031',
            id:'7031'
          },
          {
            label: 'menu.sys036',//差旅地址维护
            path: '/pms/travelAddress_toList.action',
            permission: 'taxcloud5095',
            id:'5095'
          },
          {
            label: 'menu.sys037',//报销说明项设置
            path: '/cost/userDefinedCostAction_initDefinedDescripItem.action',
            permission: 'taxcloud5093',
            id:'5093'
          },          {
            label: 'menu.sys038',//自定义功能开关
            path: '/budget/loadSwitchForNoBudget.action',
            permission: 'taxcloud5094',
            id:'5094'
          }
        ]
      },
      {
        label: 'menu.sys039',//数据初始化
        icon: 'm-shujuchushihua',
        permission: 'taxcloud5026',
        id:'5026',
        path: '/initData',
        children: [
          {
            label: 'menu.sys040',//项目信息初始化
            path: '/custom/projectInitAction_toImp.action',
            permission: 'taxcloud5079',
            id:'5079'
          },
          {
            label: 'menu.sys041',//基础档案信息初始化
            path: '/custom/initializationAction_initialization.action',
            permission: 'taxcloud5076',
            id:'5076'
          },
          {
            label: 'menu.sys042',//收款方帐户数据初始化
            path: '/custom/initPayeeAccountAction_initPayeeAccount.action',
            permission: 'taxcloud5078',
            id:'5078'
          }
        ]
      },
      {
        label: 'menu.sys043',//报销指南管理
        icon: 'm-baoxiaoguanli',
        permission: 'taxcloud5083',
        id:'5083',
        path: '/other/reimburseGuideAction_reimburseGuideList.action',
      },
      {
        label: 'menu.sys044',//日志管理
        icon: 'm-rizhiguanli',
        permission: 'taxcloud5185',
        id:'5185',
        path: '/pms/operationLogAction_toOperationLogIndex.action',
      },
      // {
      //   label: '',
      //   icon: 'icon-quanxianshezhi',
      //   permission: 'taxcloud',
      //   id:'',
      //   path: '',
      //   children: [
      //     {
      //       label: '',
      //       icon: 'icon-guyuan_gerenxinxi',
      //       path: '',
      //       permission: 'taxcloud',
      //       id:''
      //     }
      //   ]
      // }
    ]
  }
];

